/* eslint-disable */
import tocbot from "tocbot";
import MatchHeight from "matchheight";
import sal from "sal.js";
import { debounce } from "debounce";
import { CountUp } from "countup.js/dist/CountUp.min.js";
import zenscroll from "zenscroll";

var defaultDuration = 777; // ms
var edgeOffset = 42; // px
zenscroll.setup(defaultDuration, edgeOffset);

export default {
  init() {
    onScrollNavigation();
    salAnimations.init();
    animatedStats.init();
    phaseSteps.init();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    $(document).ready(function () {
      keepRatio(".c-gallery");

      function toggleNavigation() {
        var navButton = document.querySelector("#site-navigation-toggle");
        var icon = document.querySelector(".site-navigation__menu-icon");
        var body = document.querySelector("body");

        navButton.addEventListener(
          "click",
          function (event) {
            icon.classList.toggle("is-active");
            body.classList.toggle("is-open");
          },
          false
        );
      }
      toggleNavigation();

      function toggleSearch() {
        var searchForm = document.querySelector(
          ".menu-item--search .search-form"
        );
        var searchField = document.querySelector(
          ".menu-item--search .search-field"
        );
        var searchToggle = document.querySelector(
          ".menu-item--search .search-toggle"
        );
        let interval;

        // Open search on click and set focus.
        searchToggle.addEventListener(
          "click",
          (event) => {
            searchForm.classList.toggle("is-active");
            searchField.focus();
          },
          false
        );

        // If focus leaves search, close.
        searchField.addEventListener("focusout", (event) => {
          searchForm.classList.remove("is-active");
        });

        // If mouse leaves, close after a delay.
        searchForm.addEventListener("mouseleave", (event) => {
          interval = setInterval(function () {
            searchForm.classList.remove("is-active");
          }, 600);
        });

        // If mouse enters, stop the close of the seach.
        searchForm.addEventListener("mouseenter", (event) => {
          if (interval) {
            clearInterval(interval);
          }
        });
      }

      toggleSearch();

      function blogFilterActive() {
        var body = document.querySelector("body");
        var filterButton = document.querySelector(".blog-filter__button");
        var all = document.querySelector("#blog-filter-all");
        var insights = document.querySelector("#blog-filter-insights");
        var studioLife = document.querySelector("#blog-filter-studio-life");
        var projects = document.querySelector("#blog-filter-projects");
        var resources = document.querySelector("#blog-filter-resources");

        if (body.classList.contains("home-data")) {
          all.classList.add("blog-filter__button--active");
        }

        if (body.classList.contains("category-insights-data")) {
          insights.classList.add("blog-filter__button--active");
        }

        if (body.classList.contains("category-studio-life-data")) {
          studioLife.classList.add("blog-filter__button--active");
        }

        if (body.classList.contains("category-tdl-projects-data")) {
          projects.classList.add("blog-filter__button--active");
        }

        if (body.classList.contains("category-resources-data")) {
          resources.classList.add("blog-filter__button--active");
        }
      }
      blogFilterActive();

      if ($("#gallery-slider").length) {
        $("#gallery-slider").slick({
          arrows: false,
          autoplay: true,
          autoplaySpeed: 3000,
          cssEase: "ease-in-out",
          fade: true,
        });
      }

      if ($("#client-slider").length) {
        var time = 6;
        var $bar, $slick, tick, percentTime, slideCount;

        $slick = $("#client-slider");

        $slick.slick({
          speed: 600,
          cssEase: "ease-in-out",
          fade: true,
          adaptiveHeight: true,
          prevArrow: null,
          nextArrow: $(".client-slider__progress-next"),
        });

        slideCount = $slick.slick("getSlick").slideCount;

        // Add a class to the slider wrapper depending on slide count.
        $(".client-slider").addClass(`client-slider--${slideCount}`);

        // Only run the progress bar if we have more than 1 slide.
        if (slideCount > 1) {
          $bar = $(".client-slider__progress-bar");

          $(".client-slider__progress-next").click(function () {
            startProgressbar();
          });

          function startProgressbar() {
            resetProgressbar();
            percentTime = 0;
            tick = setInterval(interval, 10);
          }

          function interval() {
            percentTime += 1 / (time + 0.1);
            $bar.css({
              width: percentTime + "%",
            });
            if (percentTime >= 100) {
              $slick.slick("slickNext");
              startProgressbar();
            }
          }

          function resetProgressbar() {
            $bar.css({
              width: 0 + "%",
            });
            clearTimeout(tick);
          }

          startProgressbar();
        }
      }

      if ($("#timeline-slider").length) {
        $("#timeline-slider").slick({
          arrows: false,
          infinite: false,
          slidesToShow: 8,
          autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 6,
              },
            },
            {
              breakpoint: 960,
              settings: {
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
              },
            },
          ],
        });
      }

      function keepRatio(elem) {
        $(elem).each(function (index, value) {
          var $this = $(this);
          var w = $this.width();
          var h = $this.height();
          var ratio = w / h;
          var oh = $this.data("height");
          var onLoadRatio = 1360 / oh;

          // Update the height on load
          var nh = $(window).width() / onLoadRatio;
          if (nh <= oh) {
            $this.css("height", nh + "px");
          }

          $(window).resize(function () {
            var rh = $this.width() / onLoadRatio;
            if (rh <= oh) {
              $this.css("height", rh + "px");
            }
          });
        });
      }

      // $("#site-navigation-toggle").on("click tap", function() {
      // 	$(".site-navigation__menu-icon").toggleClass("is-active");
      // 	$("body").toggleClass("is-open");
      // });
    });

    function toggleToc() {
      const toc = document.querySelector(".anchor-navigation-wrapper");
      document.body.classList.toggle("has-active-anchor-nav");

      const isOpen = document.body.classList.contains("has-active-anchor-nav");
      document.body.style.overflow = isOpen ? "hidden" : "";
    }

    const toc = document.querySelector(".anchor-navigation");
    const tocToggle = document.querySelector(".anchor-navigation__toggle");

    if (toc !== null) {
      tocToggle.addEventListener("click", toggleToc);

      tocbot.init({
        tocSelector: ".anchor-navigation",
        listClass: "anchor-navigation__list",
        listItemClass: "anchor-navigation__item",
        linkClass: "anchor-navigation__link",
        positionFixedSelector: ".anchor-navigation",
        contentSelector: ".anchor-navigation-content",
        headingSelector: "h2, h3",
        hasInnerContainers: true,
        scrollEndCallback: function (e) {
          const active = document.querySelector(".is-active-li");
          let parent = active.parentElement.parentElement;

          document.body.classList.remove("has-active-anchor-nav");
          document.body.style.overflow = "";

          if (parent.classList.contains("anchor-navigation__item")) {
            parent.classList.add("is-active-li");
          }
        },
      });

      $(".anchor-navigation__list .anchor-navigation__list").before(
        '<button class="anchor-navigation__open">Toggle</button>'
      );
      $(".anchor-navigation__open").click(function (event) {
        $(".anchor-navigation__open").not(this).removeClass("is-active");
        $(".anchor-navigation__open")
          .not(this)
          .next()
          .removeClass("is-expanded");
        $(this).toggleClass("is-active");
        $(this).next().toggleClass("is-expanded");
      });
    }
  },
};

const animatedStats = {
  init() {
    // Options to pass into Countup.JS
    let options = {
      duration: 2,
      useEasing: true,
      useGrouping: true,
      separator: "",
      decimal: "",
    };

    // Get all numbers on the page
    let yearInNumbersDigits = $(".c-animated-stats-wrapper .number");

    // Let observe when an number element is visible on the page before starting out animation
    let observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          // Element is in the viewport
          let countTo = entry.target.dataset.value;
          let numberAnimation = new CountUp(entry.target, countTo, options);
          numberAnimation.start();
          // observer.unobserve(entry.target); -> uncomment this to only trigger the countup animation once
        } else {
          // Element is out the viewport
        }
      });
    });

    // Run the observer
    yearInNumbersDigits.each(function (index) {
      observer.observe(yearInNumbersDigits[index]);
    });
  },
};

const salAnimations = {
  init() {
    sal({
      threshold: 0.2,
    });
  },
};

const phaseSteps = {
  init() {
    phaseSteps.arrowWidths();
    phaseSteps.toggle();
    MatchHeight.init();

    /*
    window.addEventListener("load", (event) => {
      phaseSteps.arrowWidths();
      phaseSteps.toggle();
      MatchHeight.init();
    });
    */

    window.addEventListener("resize", (event) => {
      window.addEventListener("resize", debounce(phaseSteps.arrowWidths, 200));
    });
  },

  arrowWidths() {
    const phaseStepsHeadings = document.querySelectorAll(
      ".phase-steps .phase-step .headings"
    );

    if (!phaseStepsHeadings.length) {
      return;
    }

    phaseStepsHeadings.forEach((phaseStepsHeading, index) => {
      if (phaseStepsHeadings[index + 1]) {
        const distance = distanceBetweenElements(
          phaseStepsHeadings[index],
          phaseStepsHeadings[index + 1]
        );
        const arrow = phaseStepsHeadings[index].querySelector(".arrow");
        const offset = 55;
        arrow.style.width = distance - offset + "px";
      }
    });
  },

  toggle() {
    const phaseStepsGroups = document.querySelectorAll(".phase-steps-wrapper");

    if (!phaseStepsGroups.length) {
      return;
    }

    phaseStepsGroups.forEach((phaseStepsGroup) => {
      const toggleTitles = phaseStepsGroup.querySelectorAll(".phase-panel");

      if (!toggleTitles.length) {
        return;
      }

      function toggleOpen(e) {
        if (!e.target.hasAttribute("data-toggler")) {
          return;
        }

        let opened = phaseStepsGroup.getElementsByClassName("active")[0];

        if (opened != undefined && opened != this) {
          opened.classList.toggle("active");
        }

        this.classList.toggle("active");
      }

      toggleTitles.forEach((title) => {
        title.addEventListener("click", toggleOpen);
      });
    });
  },
};

function distanceBetweenElements(elementOne, elementTwo) {
  return (
    elementTwo.offsetLeft - (elementOne.offsetWidth + elementOne.offsetLeft)
  );
}

function onScrollNavigation() {
  var previousPosition =
    window.pageYOffset || document.documentElement.scrollTop;

  window.onscroll = function () {
    var currentPosition =
      window.pageYOffset || document.documentElement.scrollTop;
    var navigation = document.getElementsByClassName("site-header")[0];
    var navigationOffset = document.getElementsByClassName(
      "site-header--fixed-spacing"
    )[0];

    if (window.pageYOffset >= 320) {
      if (previousPosition > currentPosition) {
        navigation.classList.add("is-fixed");
        navigationOffset.classList.add("is-fixed");
        document.body.classList.add("header-is-fixed");
      } else {
        navigation.classList.remove("is-fixed");
        navigationOffset.classList.remove("is-fixed");
        document.body.classList.remove("header-is-fixed");
      }
    }
    if (window.pageYOffset <= 240) {
      navigation.classList.remove("is-fixed");
      navigationOffset.classList.remove("is-fixed");
      document.body.classList.remove("header-is-fixed");
    }

    previousPosition = currentPosition;
  };
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js